const main = 'samples'
const relativeRoutes = {
  relativePage: `${main}/*`,
  relativeList: `${main}`,
  relativeDetail: ':id',
}

const routes = {
  List: `/${main}`,
  Details: `/${main}/${relativeRoutes.relativeDetail}`,
}

const SamplesRoutes = { ...relativeRoutes, ...routes }

export default SamplesRoutes
